{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Смотреть все варианты",
  "Spoiler_Reveal_Tooltip": "Кликните, чтобы раскрыть",
  "VerticalEmbed_Event_Error_Subtitle": "Это событие удалено, замените его другим событием.",
  "Viewer_Toolbar_Twitter_Tooltip": "Твитнуть",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Товар в свернутом списке",
  "Spoiler_Reveal_Video_CTA": "Показать",
  "VerticalEmbed_Pricing_Plan": "Только по абонементу",
  "Image_Expand_Button_AriaLabel": "Раскрыть фото",
  "VerticalEmbed_From_Price": "От",
  "Poll_Viewer_ShowAllResults_CTA": "Смотреть все результаты",
  "Spoiler_Reveal_Image_Placeholder": "Изображение содержит спойлер",
  "VerticalEmbed_Ribbon": "Скидки",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Найти слайдер",
  "VerticalEmbed_Error_Subtitle": "Этот элемент удален. Замените его другим элементом.",
  "Poll_Viewer_Multiselect_Footer": "Вы можете проголосовать за несколько вариантов.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Показать больше элементов управления аудио",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Не удалось загрузить услугу",
  "Fullscreen_Close_Button_AriaLabel": "Закрыть",
  "VerticalEmbed_Event_Fetch_Error_Title": "Не удалось загрузить событие",
  "UploadFile_Viewer_Loader": "Загрузка {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Аватар пользователя",
  "Preview_ReadMore_Label": "Подробнее",
  "Spoiler_Insert_Tooltip": "Спойлер",
  "VerticalEmbed_Product_Fetch_Error_Title": "Не удалось загрузить товар",
  "Fullscreen_Shrink_Button_AriaLabel": "Уменьшение",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Громкость",
  "Spoiler_Reveal_Gallery_Placeholder": "В галерее есть спойлер",
  "Fullscreen_Expand_Button_AriaLabel": "Раскрыть",
  "VerticalEmbed_Bookings_Button": "Забронировать",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Включить",
  "Spoiler_Reveal_Gallery_CTA": "Показать",
  "Poll_Viewer_ShowLess_CTA": "Свернуть",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Отключить",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} анонимно",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Следить",
  "VerticalEmbed_Products_Button": "Купить",
  "Poll_Viewer_Toast_Error_ServerDown": "Не удалось подключиться к серверу. Попробуйте позже.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "За этот ответ проголосовали {{count}} чел.",
  "Poll_Viewer_VoteCount": "Голосов: {{number}}",
  "VerticalEmbed_Events_Button": "Зарегистрироваться",
  "Spoiler_Reveal_Image_CTA": "Показать",
  "Poll_Viewer_Toast_Error_Connection": "Нет сети. Проверьте соединение.",
  "Poll_Viewer_Visibility_Owner_Footer": "Только вы видите результаты.",
  "VerticalEmbed_Booking_Error_Title": "Услуга удалена",
  "VerticalEmbed_Product_Error_Title": "Товар удален",
  "VerticalEmbed_Fetch_Error_Subtitle": "Не удалось загрузить информацию о элементе.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "За этот ответ проголосовали {{count}} чел.",
  "VerticalEmbed_Event_Error_Title": "Событие удалено",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Товар в развернутом списке",
  "Audio_Plugin_Cover_Alt": "Обложка аудио",
  "Spoiler_Reveal_Video_Placeholder": "Видео содержит спойлер",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Возникла техническая проблема. Проверьте соединение и попробуйте снова.",
  "VerticalEmbed_Fetch_Error_Title": "Не удалось загрузить элемент",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Товар удален. Замените его на другой товар.",
  "VerticalEmbed_Booking_Error_Subtitle": "Услуга удалена. Замените ее на другую услугу.",
  "Preview_SeeFullPost_Label": "Показать весь пост",
  "UploadFile_Viewer_Download": "Скачать {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} ч.",
  "VerticalEmbed_Units_Minute": "{{minutes}} мин.",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Возникла техническая проблема. Проверьте соединение и попробуйте снова.",
  "VerticalEmbed_Error_Button": "Заменить",
  "VerticalEmbed_Error_Title": "Элемент удален",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Возникла техническая проблема. Проверьте соединение и попробуйте снова.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
